class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.predictiveSearch = this.querySelector('predictive-search');
    this.body = document.querySelector('body');

    this.onScrollHandler = this.onScroll.bind(this);

    this.onScrollHandler;

    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const announcementBarheight = document.querySelector("#shopify-section-announcement-bar").offsetHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop < announcementBarheight) {
      this.hide();
    } else {
      this.reveal();
    }
  }

  hide() {
    this.header.classList.remove('shopify-section-header-sticky');
    this.body.classList.remove('sticky-header-active');
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky');
    this.body.classList.add('sticky-header-active');
  }
}

customElements.define('sticky-header', StickyHeader);